module.exports = __webpack_public_path__ + "images/emoji/clock330.691bcc0dc3d4c74efe72.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock330.png
// module id = Yqjb
// module chunks = 2